import React from 'react';

const AGBPage = () => (
  <main style={{ padding: '2rem', maxWidth: '800px', margin: '0 auto' }}>
    <h1>Allgemeine Geschäftsbedingungen</h1>
    <p style={{ whiteSpace: 'pre-line' }}>
      {`
1.Geltungsbereich
Diese Allgemeinen Geschäftsbedingungen (nachfolgend bezeichnet als „AGB“)
gelten für alle Rechtsgeschäfte zwischen Chiara Körner, Lodenweg 6 59581
Warstein (nachfolgend bezeichnet als ,,Online-Dienstleister“) und Ihnen als Käufer
(nachfolgend bezeichnet als „Kunde“ oder „Käufer“).
Der Begriff „Kunde“ oder „Käufer“ bezieht sich in diesen AGB selbstverständlich auf
Personen aller Geschlechter.
Verbraucher ist jede natürliche Person, die ein Rechtsgeschäft zu Zwecken
abschließt, die überwiegend weder ihrer gewerblichen noch ihrer selbständigen
beruflichen Tätigkeit zugerechnet werden können.
Unternehmer ist eine natürliche oder juristische Person oder eine rechtsfähige
Personengesellschaft, die bei Abschluss eines Rechtsgeschäfts in Ausübung ihrer
gewerblichen oder selbständigen beruflichen Tätigkeit handelt.
Der Online-Dienstleister erbringt alle beschriebenen Leistungen ausschließlich auf
Grundlage dieser Allgemeinen Geschäftsbedingungen. Abweichende
Geschäftsbedingungen des Kunden werden auch dann nicht Vertragsbestandteil,
wenn der Online-Dienstleister ihrer Geltung nicht ausdrücklich widerspricht.
2. Vertragsgegenstand/Leistungsbeschreibung
Die Parteien sind sich einig, dass die Produkte Kursinhalte enthalten, welche jedoch
einen freien, aktiven und selbstverantwortlichen Prozess des Käufers erfordern und
bestimmte Erfolge von Seiten des Online-Dienstleisters nicht garantiert werden
können.
Digitale Produkte werden dem Kunden in elektronischer Form, entweder als
Download, als Login im Onlineshop, im Member-Bereich auf der Website oder per E-
Mail zur Verfügung gestellt. Die Inhalte der Programme sind jeweils auf der Website
des Online-Dienstleisters ersichtlich. Es gelten die zum Zeitpunkt der Buchung
vereinbarten Inhalte und Leistungen.
Sollte ein „lebenslanger Zugang“ zu Produkten gewährt werden, so bezieht sich
dieser auf die Möglichkeit, auf ein Produkt oder eine Dienstleistung während der
gesamten Lebensdauer des Produkts zuzugreifen, solange es auf der jeweiligen
Plattform verfügbar ist.
3. Vertragsschluss
Der Vertrag zwischen dem Kunden und dem Online-Dienstleister kommt wie folgt
zustande:
1) Unter https://chiara-koerner.com findest du den Button Erstgespräch vereinbaren
oder E-Mail senden. Außerdem bewerbe ich meine Programme über Facebook und
auch Instagram. Hier erhältst du jeweils einen Link zu meinem Terminbuchungstool
oder meiner Webseite. Bei meinen Programmen bildet das vorbereitende
Erstgespräch zwischen dir und mir die Grundlage für die Beratungsleistung. Du
nimmst telefonisch Kontakt mit mir auf oder per E-Mail bzw. buchst dein kostenloses
Erstgespräch. Das Erstgespräch dauert ca. 15 Minuten und findet telefonisch statt.
(2) Möchtest du einen Termin über meinen Terminkalender buchen, klicke auf den
Button: „Jetzt dein kostenloses Erstgespräch buchen“. Ich nutze hierfür den Anbieter
Calendly.
(3) Wenn du dort klickst, öffnet sich eine Seite, auf der dir mögliche Termine
angezeigt werden. Du wählst einen Termin aus und hinterlegst deinen Namen, deine
E-Mailadresse und deine Telefonnummer. Diese Angaben werden selbstverständlich
nur für die Vorbereitung unseres Zoom-Calls genutzt. Kommt kein Vertrag mit dir
zustande, lösche ich diese Daten umgehend. Über den Button „Buchung bestätigen“,
buchst du deinen ausgewählten Termin. Im Anschluss erhältst du eine
entsprechende Buchungsbestätigung per E-Mail.
(4) Im Erstgespräch lernen wir uns kennen und klären, an welchem Punkt du
persönlich in deinem Leben aktuell stehst. Wenn alles passt, vereinbarst du einen
weiteren Termin für einen Zoom-Call mit mir.
(5) Im Anschluss an dieses erste Gespräch sende ich dir einen Link für den Zoom-
Call. Mit diesem Link erhältst du auch einen Link zu diesen AGB.
(6) In unserem Zoom-Call klären wir, welches Programm für dich passend ist. Zu
dem jeweiligen Programm erhältst du dann umfangreiche Informationen. Der Zoom-
Call dauert ca. 45-60 Minuten.
(7) Wenn du mir in diesem Gespräch mündlich zusicherst, Interesse an der Buchung
des Programms zu haben, sende ich dir während unseres Gesprächs den
entsprechenden Link zur Buchung des Programms oder eine Rechnung des
ausgewählten Angebotes und unterstütze ggf. bei noch auftretenden Fragen.
(8) Zur Kaufabwicklung wirst du dann auf eine Seite der AblefyGmbH weitergeleitet.
Auf dieser Seite findest du noch mal alle Informationen, Inhalte und den Preis des
jeweiligen Programms. Außerdem kannst du dort auswählen, ob du als Privatperson
oder Unternehmen kaufst sowie anschließend deine E-Mail-Adresse und deinen Vor-
und Nachnamen eingeben, sowie deine Adresse und als Unternehmen deinen
Firmennamen und deine USt.IDNr. Weiter unten kannst du zwischen den
verschiedenen Zahlungsmöglichkeiten wählen. Bitte beachte, dass es bei digitalen
Produkten und auch bei Onlinekurs-Zugängen –je nachdem, welche Zahlungsart du
wählst–zu Verzögerungen bei der Auslieferung per E-Mail bzw. bei der Zusendung
der Zugangsdaten kommen kann. Das Programm ist so eingestellt, dass das digitale
Produkt/ Onlinekurs Zugänge erst dann versandt werden, wenn die Zahlung
eingegangen ist. D.h. wenn du dich für die Zahlung per Vorkasse entscheidest, dann
kann es bis zu 5 Tage dauern, bis du unser Produktausgeliefert bekommen bzw.
einen Onlinekurs nutzen kannst.
(9) Wenn du einen Gutschein-Code hast, kannst du diesen nun ebenfalls eingeben.
(10) Als Zahlungsmöglichkeiten steht dir die Zahlung per PayPal, Sofort-Zahlung,
Vorkasse und SEPA-Lastschrift zur Verfügung. Du erhältst von mir eine Rechnung
per E-Mail. Der gesamte Rechnungsbetrag bzw. der ausgewiesene erste
Ratenzahlungsbetrag ist sofort fällig. Sobald deine Zahlung bzw. Anzahlung
eingegangen ist, hast du Anspruch auf das erworbene Programm.
1. a) PayPal: Durch Auswählen der Zahlungsart „PayPal“ und der Bestätigung
„Jetzt Kaufen“ wirst du auf die Log-In Seite von PayPal weitergeleitet. Nach
erfolgreicher Anmeldung werden deine bei PayPal hinterlegten Adress- und
Kontodaten angezeigt. Die Zahlungsabwicklung erfolgt über PayPal zu deren
Bedingungen. Anbieter des Dienstes ist PayPal (Europe) S.à r.l. et Cie,
S.C.A., 22-24 Boulevard Royal, L2449 Luxembourg (im Folgenden: "PayPal"),
unter Geltung der PayPal-Nutzungsbedingungen, einsehbar unter
https://www.paypal.com/de/webapps/mpp/ua/useragreement-full.
2. b) Bei Auswahl der Zahlungsart „SOFORT“ erfolgt die Zahlungsabwicklung
über den Zahlungsdienstleister SOFORT GmbH, Theresienhöhe 12, 80339
München (im Folgenden „SOFORT“). Um den Rechnungsbetrag über
„SOFORT“ bezahlen zu können, musst du über ein für die Teilnahme an
„SOFORT“ frei geschaltetes Online-Banking-Konto mit PIN/TAN-Verfahren
verfügen, dich beim Zahlungsvorgang entsprechend legitimieren und die
Zahlungsanweisung gegenüber „SOFORT“ bestätigen. Die
Zahlungstransaktion wird unmittelbar danach von „SOFORT“ durchgeführt und
dein Bankkonto belastet. Nähere Informationen zur Zahlungsart „SOFORT“
kannst du im Internet unter https://www.klarna.com/sofort/ abrufen.
(c) Vorkasse: Durch Auswählen von “Vorkasse“ und Klick auf den Button „Jetzt
kaufen“ erhältst du eine Mail von mir mit den Überweisungsdaten.
(d) Lastschrift: Du trägst deine Kontodaten bei Auswahl der SEPA-Lastschrift
ein und bestätigst dies mit dem Button „Jetzt kaufen“.
(11) Vor Abschluss der Bestellung gibst du mit dem Klick in die jeweiligen
Kästchen deine Einwilligung • zur Speicherung und Verarbeitung deiner Daten
• zur Geltung dieser AGB
• zur Geltung der Datenschutzerklärung.
Sämtliche Texte findest du dort verlinkt vor. Außerdem musst du dich damit
einverstanden erklären, dass du auf dein Widerrufsrecht verzichtest.
(12) Abschließend klickst du auf den Button „Jetzt Kaufen“ und gibst damit ein
verbindliches Angebot an mich ab. Damit bietest du mir den Abschluss eines
Kaufvertrags über die Buchung an.
(13) Unmittelbar nach Absenden erhältst du eine Bestätigungsmail von mir. In
diesem Moment kommt ein Vertrag zwischen uns zustande. Der Kunde
akzeptiert diese AGB durch das ausdrückliche Annehmen oder die
tatsächliche Inanspruchnahme der Dienstleistungen.
4. Preise und Zahlungsbedingungen
Es gelten die zum Zeitpunkt der Bestellung angegebenen Preise und diese
verstehen sich inklusive aller anwendbaren Steuern und Gebühren. Die Zahlung
erfolgt mittels der im Onlineshop zur Verfügung gestellten Zahlungsarten.
Auf Anfrage oder Verfügbarkeit im Onlineshop kann eine Ratenzahlung vereinbart
werden.
Sollte eine Ratenzahlung ausbleiben, kommt der Kunde automatisch in Verzug und
der Online-Dienstleister kann Verzugszinsen in gesetzlich festgelegter Höhe
berechnen.
Der Anbieter behält sich bei ausbleibenden Zahlungen jederzeit das Recht vor, den
Zugang zu den Dienstleistungen im Falle des Verzugs des Kunden vorübergehend
oder dauerhaft zu sperren.
Gegen Forderungen des Anbieters kann der Kunde nur mit unbestrittenen oder
rechtskräftig festgestellten oder entscheidungsreifen Gegenansprüchen aufrechnen.
Der Kunde akzeptiert diese AGB durch das ausdrückliche Annehmen oder die
tatsächliche Inanspruchnahme der Dienstleistungen.
Widerrufsrecht
Verbrauchern in der Europäischen Union steht ein Widerrufsrecht nach folgender
Massgabe zu, wobei Verbraucher jede natürliche Person ist, die ein Rechtsgeschäft
zu Zwecken abschliesst, die überwiegend weder ihrer gewerblichen noch ihrer
selbständigen beruflichen Tätigkeit zugerechnet werden können.
A. WIDERRUFSBELEHRUNG
Widerrufsrecht
Sie haben das Recht, binnen vierzehn (14) Tagen ohne Angabe von Gründen diesen
geschlossenen Vertrag zu widerrufen.
Die Widerrufsfrist beträgt vierzehn (14) Tage ab dem Tag des Vertragsschlusses.
Um Ihr Widerrufsrecht auszuüben, müssen Sie mir Chiara Körner, Lodenweg 6,
59581 Warstein E-Mail: ckorner32@gmail.com , Tel.: 01784590988 mittels einer
eindeutigen Erklärung (z.B. Brief oder E-Mail) über Ihren Entschluss, diesen Vertrag
zu widerrufen, informieren.
Sie können dafür das beigefügte Widerrufsformular verwenden, das jedoch nicht
vorgeschrieben ist.
Zur Wahrung der Widerrufsfrist reicht es aus, dass Sie die Mitteilung über die
Ausübung des Widerrufsrechts vor Ablauf der Widerrufsfrist absenden.
Folgen des Widerrufs
Wenn Sie diesen Vertrag widerrufen, haben wir Ihnen alle Zahlungen, die wir von
Ihnen erhalten haben, unverzüglich und spätestens binnen vierzehn (14) Tagen ab
dem Tag zurückzuzahlen, an dem die Mittelung über Ihren Widerruf dieses Vertrages
bei uns eingegangen ist. Für diese Rückzahlung verwenden wir dasselbe
Zahlungsmittel, das Sie bei der ursprünglichen Transaktion eingesetzt haben, es sei
denn, mit Ihnen wurde ausdrücklich etwas anderes vereinbart; in keinem Fall werden
Ihnen wegen dieser Rückzahlung Entgelte berechnet.
Haben Sie verlangt, dass die Dienstleistungen bereits während der Widerrufsfrist
beginnen sollen, so haben Sie uns einen angemessenen Betrag zu zahlen, der dem
Anteil der bis zu dem Zeitpunkt, zu dem Sie mich von der Ausübung des
Widerrufsrechts hinsichtlich dieses Vertrages unterrichten, bereits erbrachten
Dienstleistungen im Vergleich zum Gesamtumfang der im Vertrag vorgesehen
Dienstleistungen entspricht. Sollte die Dienstleistung vor Ablauf der Widerrufsfrist
vollständig erbracht worden sein, erlischt das Widerrufsrecht.
B. WIDERRUFSFORMULAR
Wenn Sie den Vertrag widerrufen wollen, dann füllen Sie bitte dieses Formular aus
und senden es zurück.
An
Chiara Körner, Lodenweg 6 59581 Warstein
E-Mail: ckorner32@gmail.com
Tel.: 01784590988
Hiermit widerrufe(n) ich/wir (*) den von mir/uns (*) abgeschlossenen Vertrag über den
Kauf der folgenden Waren
_______________________________________________________
_______________________________________________________
Bestellt am (*) ____________ / erhalten am (*) __________________
________________________________________________________
Name des/der Verbraucher(s)
________________________________________________________
Anschrift des/der Verbraucher(s)
________________________________________________________
Unterschrift des/der Verbraucher(s) (nur bei Mitteilung auf Papier) Datum
_________________________
1.Laufzeit und Kündigung
Nach Ablauf der Laufzeit oder Erfüllung der vereinbarten oder gebuchten
Dienstleistung endet diese automatisch und bedarf keiner Kündigung.
Das Recht zur außerordentlichen Kündigung aus wichtigem Grund bleibt unberührt.
2. Haftungsausschluss
Der Online-Dienstleister übernimmt keine Haftung für Schäden, die durch die
Nutzung der Dienstleistungen entstehen, es sei denn, sie beruhen auf Vorsatz oder
grober Fahrlässigkeit seitens des Dienstleisters. Dieser Haftungsausschluss gilt nicht
für Schäden aus der Verletzung des Lebens, des Körpers oder der Gesundheit sowie
bei Verletzung wesentlicher Vertragspflichten.
Im Übrigen ist, soweit gesetzlich möglich, jegliche Haftung ausgeschlossen.
3. Datenschutz
Der Online-Dienstleister verarbeitet personenbezogene Daten des Kunden gemäß
den geltenden Datenschutzbestimmungen. Nähere Informationen zur Erhebung,
Verarbeitung und Nutzung der Daten finden sich in der Datenschutzerklärung des
Dienstleisters, die auf der Webseite abrufbar ist.
4. Geistiges Eigentum
Alle Rechte an geistigem Eigentum, einschließlich Urheberrechten und
Markenrechten, in Bezug auf die Dienstleistungen verbleiben beim Online-
Dienstleister. Der Kunde erhält lediglich ein nicht übertragbares, nicht
ausschließliches Nutzungsrecht an den Inhalten
des Online-Dienstleisters, das ausschließlich für den persönlichen Gebrauch
bestimmt ist.
Eine Vervielfältigung, Verbreitung oder Verwendung der Inhalte für kommerzielle
Zwecke bedarf der ausdrücklichen Zustimmung des Online-Dienstleisters.
5. Gerichtsstand und anwendbares Recht
Für sämtliche Streitigkeiten aus oder im Zusammenhang mit diesen AGB gilt
ausschließlich das Recht der Bundesrepublik Deutschland unter Ausschluss des UN-
Kaufrechts. Sofern der Kunde Kaufmann, eine juristische Person des öffentlichen
Rechts oder ein öffentlich-rechtliches Sondervermögen ist, wird als ausschließlicher
Gerichtsstand der Sitz des Online-Dienstleisters vereinbart.
6. Sonstige Bestimmungen
Änderungen oder Ergänzungen dieser AGB bedürfen der Schriftform. Sollten
einzelne Bestimmungen dieser AGB ganz oder teilweise unwirksam sein oder
werden, bleibt die Wirksamkeit der übrigen Bestimmungen unberührt.
Der Online-Dienstleister behält sich das Recht vor, die AGB jederzeit zu ändern oder
zu aktualisieren. Änderungen werden dem Kunden rechtzeitig mitgeteilt und gelten
als angenommen, sofern der Kunde nicht innerhalb einer angemessenen Frist nach
Erhalt der Mitteilung widerspricht.`}
    </p>
  </main>
);

export default AGBPage;